function getHexagonForLevel1Id(country, date, level1Id, resolution) {
  return `${process.env.REACT_APP_API_URL}/api/hex_map?date=${date}&country=${country}&state=${level1Id}&resolution=${resolution}`
  // return `/data/${country}/distancing/hexagon_map/date=${date}/resolution=${resolution}/level_1_id=${level1Id}.json`;
}

export const urls = {
  getHexagonForLevel1Id,
  getStateHexagons: getHexagonForLevel1Id,
};
